var render = function render(){var _vm=this,_c=_vm._self._c;return _c('transition-group',{staticClass:"TheToaster toaster-list",attrs:{"name":"toaster-transition","tag":"div"}},_vm._l((_vm.list),function(item){return _c('TheToasterItem',_vm._b({key:item.id,staticClass:"toaster-list-item",on:{"hide":function($event){return _vm.removeItem(item.id)}}},'TheToasterItem',item,false))}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }